export const GET_TOTAL_NOTIFICATION_ACTION = "GET_TOTAL_NOTIFICATION_ACTION";
export const SET_TOTAL_NOTIFICATION_ACTION = "SET_TOTAL_NOTIFICATION_ACTION";

export const GET_LIST_NOTIFICATION_ACTION = "GET_LIST_NOTIFICATION_ACTION";
export const SET_LIST_NOTIFICATION_ACTION = "SET_LIST_NOTIFICATION_ACTION";

export const GET_NOTIFICATION_DETAIL_ACTION = "GET_NOTIFICATION_DETAIL_ACTION";
export const SET_NOTIFICATION_DETAIL_ACTION = "SET_NOTIFICATION_DETAIL_ACTION";

export const POST_WATCHED_NOTIFICATION_ACTION =
	"POST_WATCHED_NOTIFICATION_ACTION";

export const MENU_NOTIFICATION_ACTION = "MENU_NOTIFICATION_ACTION";
